import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/assets/images/flowers.webp");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/assets/images/marcello.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/assets/images/portrets/christy.webp");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/assets/images/portrets/johannes.webp");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/assets/images/siebren.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/assets/images/stats/100.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/assets/images/stats/9 of 10.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/assets/images/stats/92.png");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/assets/images/subjects.webp");
;
import(/* webpackMode: "eager", webpackExports: ["VisualGrid"] */ "/home/runner/work/Teelor/Teelor/components/home/approach/VisualGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContentBlock"] */ "/home/runner/work/Teelor/Teelor/components/home/contact/ContentBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Buttons"] */ "/home/runner/work/Teelor/Teelor/components/home/hero/Buttons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/Teelor/Teelor/components/home/Office.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Buttons"] */ "/home/runner/work/Teelor/Teelor/components/home/subjects/Buttons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Buttons"] */ "/home/runner/work/Teelor/Teelor/components/home/teelor/Buttons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArrowButton"] */ "/home/runner/work/Teelor/Teelor/components/ui/buttons/ArrowButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchInput"] */ "/home/runner/work/Teelor/Teelor/components/ui/inputs/SearchInput.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Teelor/Teelor/node_modules/next/dist/client/image-component.js");
